// random nonce of 6 chars
export function randomNonce() {
  return Math.random().toString(16).slice(2);
}

export function lexicalOrder(a: string, b: string) {
  return a > b ? 1 : a < b ? -1 : 0;
}

export function unknownToString(value: any) {
  const t: null | string = typeof value;
  let c: null | string = null;
  let s: null | string = null;

  try {
    c = value && value.constructor && value.constructor.name;
  } catch (e) {}

  try {
    s = JSON.stringify(value);
  } catch (e) {}

  try {
    s = s || String(value);
  } catch (e) {}

  c = c || '[Unknown]';
  s = s || '[unknown]';

  return `${t}/${c}/${s} `;
}

export function padString(orig: number | string, pad = '0', length = 2) {
  let padded = String(orig);
  while (padded.length < length) {
    padded = pad + padded;
  }
  return padded;
}

// ローカルタイムゾーンでの YYYY-mm-dd HH:MM:SS
export function formatNoTz(date: Date) {
  const dateStr = [
    `${date.getFullYear()}-`,
    `${padString(date.getMonth() + 1)}-`,
    `${padString(date.getDate())}`,
    ` ${padString(date.getHours())}:`,
    `${padString(date.getMinutes())}:`,
    `${padString(date.getSeconds())}`,
  ].join('');

  return dateStr;
}

// YYYY-m-dd
export function formatYYYYMMDD(date: Date) {
  return [String(date.getFullYear()), padString(date.getMonth() + 1), padString(date.getDate())].join('-');
}

/**
 * timestampをJSTとみなしてフォマットする
 * @param utcTimestamp
 * @return YYYY-MM-DD HH:MM:SS
 * @note "dangerous": offsetだけ矯正したため、daylight saving timeなどを考えない
 *       引数がNaNだった場合は、空文字列を返す
 */
export function formatYYYYMMDDHHMMSSJstDangerously(utcTimestamp: number) {
  if (Number.isNaN(utcTimestamp)) return '';

  const offsetAdjustedDate = new Date(utcTimestamp + 3600e3 * 9);

  return [
    String(offsetAdjustedDate.getUTCFullYear()),
    '-',
    padString(offsetAdjustedDate.getUTCMonth() + 1),
    '-',
    padString(offsetAdjustedDate.getUTCDate()),
    ' ',
    padString(offsetAdjustedDate.getUTCHours()),
    ':',
    padString(offsetAdjustedDate.getUTCMinutes()),
    ':',
    padString(offsetAdjustedDate.getUTCSeconds()),
  ].join('');
}

/**
 * timestampをJSTとみなしてフォマットする
 * @param utcTimestamp
 * @return YYYY-MM-DD HH:MM:SS
 * @note "dangerous": offsetだけ矯正したため、daylight saving timeなどを考えない
 *       引数がNaNだった場合は、空文字列を返す
 */
export function formatYYYYMMDDHHMMJstDangerously(utcTimestamp: number) {
  if (Number.isNaN(utcTimestamp)) return '';

  const offsetAdjustedDate = new Date(utcTimestamp + 3600e3 * 9);

  return [
    String(offsetAdjustedDate.getUTCFullYear()),
    '-',
    padString(offsetAdjustedDate.getUTCMonth() + 1),
    '-',
    padString(offsetAdjustedDate.getUTCDate()),
    ' ',
    padString(offsetAdjustedDate.getUTCHours()),
    ':',
    padString(offsetAdjustedDate.getUTCMinutes()),
  ].join('');
}

export function prettyJson(value: unknown) {
  return JSON.stringify(value, null, 2);
}

/**
 *
 * @param origString
 * @param keyword
 * @param ignoreCase
 * @return [before, match, after] or [origString, '', '']
 */
export function splitByMatch(origString: string, keyword: string, ignoreCase = false): [string, string, string] {
  const matchIndex = ignoreCase ? origString.toLowerCase().indexOf(keyword.toLowerCase()) : origString.indexOf(keyword);

  return matchIndex >= 0
    ? [
        origString.slice(0, matchIndex),
        origString.slice(matchIndex, matchIndex + keyword.length),
        origString.slice(matchIndex + keyword.length),
      ]
    : [origString, '', ''];
}

export function commaedInteger(_integer: number | string): string {
  const integer = String(_integer);

  const segments: string[] = [];

  if (integer.length % 3) {
    segments.push(integer.slice(0, integer.length % 3));
  }

  for (let left = integer.length % 3; left < integer.length; left += 3) {
    segments.push(integer.slice(left, left + 3));
  }

  return segments.join(',');
}

export function formatRateToPercentage(rate: number) {
  const digits = (rate * 100).toFixed(1).replace(/\.0+$/, '');
  return digits + '%';
}

export function formatDigits(value: number, options: Partial<{ frictionDigits: number; withComma: boolean }> = {}) {
  if (value === undefined) return ''; // to prevent NPE

  const { frictionDigits = 1, withComma = true } = options;

  const trimmed = value.toFixed(frictionDigits);
  if (!withComma) return trimmed;

  const [before, dot, after] = splitByMatch(trimmed, '.');

  const segments = [commaedInteger(before), dot, after];
  return segments.join('');
}

export function unifyWithHalfwidthSpace(input: string): string {
  return input.replace(/[　\t]+/g, ' ');
}

export function splitBySpace(input: string): string[] {
  return input.split(/[ 　]/);
}
